import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import CaseActsTable from 'app/edozvola/cases/case-acts/case-acts-table';
import CaseActsConfirmationModal from './case-acts-confirmation-modal';
import { useParams } from 'react-router-dom';
import {
  checkCaseActAndTemplateExistsQuery,
  previewCaseActWorkingVersionFileWithDefaultTemplateQuery,
} from 'app/edozvola/cases/case-acts/service/case-acts.queries';

const CaseActs = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const { sidebarItemPair } = useContext(CaseTabContext);
  const [confirmActionModalShown, setConfirmActionModalShown] = useState<boolean>(false);
  const [shouldHideActionButtons, setShouldHideActionButtons] = useState<boolean>(false);

  const { data: caseActAndTemplateExists, isLoading: isCheckingLoading } = checkCaseActAndTemplateExistsQuery(uuid);
  const { mutate: previewCaseActMutation, isPending } = previewCaseActWorkingVersionFileWithDefaultTemplateQuery(uuid);

  useEffect(() => {
    setShouldHideActionButtons(caseActAndTemplateExists !== true);
  }, [caseActAndTemplateExists]);

  const onCreateDocumentClicked = () => {
    setConfirmActionModalShown(true);
  };

  const onPreviewDocumentClicked = () => {
    previewCaseActMutation();
  };
  const handleConfirmation = (idCaseAct: number) => {
    if (!isCheckingLoading && idCaseAct !== null) {
      setShouldHideActionButtons(true);
    }
  };

  return (
    <>
      <div className={'d-flex justify-content-between'}>
        {!sidebarItemPair?.readOnly && !shouldHideActionButtons && (
          <Button
            label={'Pregledaj dokument'}
            disabled={isPending || confirmActionModalShown}
            color="secondary"
            size="lg"
            onClick={() => onPreviewDocumentClicked()}
          ></Button>
        )}
        {!sidebarItemPair?.readOnly && !shouldHideActionButtons && (
          <>
            <Button label="Izradi dokument zahtjeva" disabled={isPending} color="info" size="lg" onClick={() => onCreateDocumentClicked()} />
            <CaseActsConfirmationModal
              uuid={uuid}
              confirmActionModalShown={confirmActionModalShown}
              setConfirmActionModalShown={setConfirmActionModalShown}
              readOnly={false}
              onConfirmed={handleConfirmation}
            />
          </>
        )}
      </div>
      <div className={'mt-3'}>
        <CaseActsTable
          onRowClick={onCreateDocumentClicked}
        />
      </div>
    </>
  );
};

export default CaseActs;
